import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { fadeInOutTranslate } from 'app/shared/elements/animation';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HRMSService } from '../shared/hrms.service';
import { GridDataResult, PageChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { DatePipe } from '@angular/common';
import { dayNames } from '../shared/constants';
import { DateService } from 'app/date/date.service';
import { SessionService } from 'app/sessions/session.service';

@Component({
  selector: 'app-holidays',
  templateUrl: './holidays.component.html',
  styleUrls: ['./holidays.component.css'],
  animations: [fadeInOutTranslate],
  providers:[DatePipe],
  encapsulation: ViewEncapsulation.None,
})
export class HolidaysComponent implements OnInit {
  holidayForm:FormGroup;
  holidays:any;
  public gridView: GridDataResult;
  public pageSize = 10;
  public skip = 0;
  isEdit = false;
  id:any;
  bsValue = new Date();
  @ViewChild('HolidayModal') holidayModal;
  @ViewChild('deleteModal') deleteModal;
  submitted:boolean = false;
  exists:any;
  constructor(private hrmsService:HRMSService, private datePipe: DatePipe, private dateService:DateService, private ss:SessionService) { }

  ngOnInit() {
    this.initilaizeForm();
    this.getAllHolidays();
  }
  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadItems();
  }
  private initilaizeForm()
  {
    this.holidayForm = new FormGroup({
      date: new FormControl(this.bsValue,Validators.required),
      day: new FormControl('',Validators.required),
      occasion: new FormControl('',Validators.required)
    });
  }
  private getAllHolidays()
  {
    var x = this.hrmsService.getAllHolidays();
  x.snapshotChanges().subscribe(item=>{
    this.holidays = [];
    item.forEach(element =>{
        this.holidays.push({
          "Date": this.dateService.getFullDate(element.payload.child("date").val()),
          "dateOfHoliday": element.payload.child("date").val(),
          "Day": String(element.payload.child("day").val()),
          "Holiday": String(element.payload.child("occasion").val()),
          "id": element.key
        });
        this.holidays.sort(function(a,b){
          var c = new Date(a.dateOfHoliday);
          var d = new Date(b.dateOfHoliday);
          return c.getTime() - d.getTime();  
          });
        this.loadItems();
    });
  });
  }

  private loadItems():void{
    this.gridView = {
      data: this.holidays.slice(this.skip, this.skip + this.pageSize),
      total: this.holidays.length
    };
  }
  public onSubmit()
  {
    this.submitted = true;
    var data = {
      date: this.dateService.getDate(this.holidayForm.value.date),
      day: this.holidayForm.value.day,
      occasion: this.holidayForm.value.occasion
    }
    
  if(this.holidayForm.valid && !this.isEdit)
  {
    this.checkHasHoliday(data);
  }
  else if(this.holidayForm.valid)
  {
    this.checkHasHolidayWhileEdit(data);
  }
  }
  checkHasHoliday(data)
  {
    this.hrmsService.checkDateExistsInHoliday(data.date).once("value").then(holiday=>{
      if(holiday.numChildren()>0)
      {
        this.exists ="Holiday is already present";
        this.submitted = false;
      }
      else
      {
        this.hrmsService.addHolidays(data).then(()=>{
          this.submitted = false;
          this.holidayForm.reset();
          this.holidayModal.hide();
          this.setFormValues();
        });
      }
    });
    
  }
  checkHasHolidayWhileEdit(data)
  {
    this.hrmsService.checkDateExistsInHoliday(data.date).once("value").then(holiday=>{
      if(holiday.numChildren()>0)
      {
        holiday.forEach(d=>{
          if(d.key == this.id)
          {
            this.hrmsService.updateHolidays(data, this.id).then(()=>{
              this.submitted = false;
              this.holidayForm.reset();
              this.holidayModal.hide();
              this.setFormValues();
              this.isEdit = false;
              this.id = null;
            });
          }
          else
          {
            this.exists ="Holiday is already present";
            this.submitted = false;
          }
        });
      }
      else
      {
        this.hrmsService.updateHolidays(data, this.id).then(()=>{
          this.submitted = false;
          this.holidayForm.reset();
          this.holidayModal.hide();
          this.setFormValues();
          this.isEdit = false;
          this.id = null;
        });
      }
    });
  }
public editHoliday(id)
{
  this.isEdit = true;
  this.id = id;
  var x = this.hrmsService.getHolidays(id);
  x.once("value").then((leaves)=>{
    this.holidayForm.get("date").setValue(new Date(leaves.child("date").val()));
    this.holidayForm.get("day").setValue(leaves.child("day").val())
    this.holidayForm.get("occasion").setValue(leaves.child("occasion").val())
  });
  this.holidayModal.show();
}
public deleteHoliday(id):void{
  this.id = id;
  this.deleteModal.show();
}
public delete():void{
  this.hrmsService.deleteHolidays(this.id).then(()=>{
    this.id = null;
    this.deleteModal.hide();
  });
}
onValueChange(value: Date): void {
  var data = value;
  if(data)
  {
    //console.log("data", dayNames[data.getDay()]);
    this.holidayForm.get("day").setValue(dayNames[data.getDay()]);
  }
}
onCloseHolidayModal()
{
  this.holidayModal.hide();
  this.holidayForm.reset();
  this.setFormValues();
}
setFormValues()
{
  this.holidayForm.get("date").setValue(this.bsValue);
  this.onValueChange(this.bsValue);
  this.exists = null;
}
public rowCallback = (context: RowClassArgs) => {
  var today = this.dateService.getTodaysDate();
  switch (context.dataItem.dateOfHoliday) {
    case today:
    //console.log("true");
      return {gold : true};
    default:
      return {};
   }
 }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/holidays/holidays.component.ts